import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "p-d-flex p-flex-row p-ai-center p-flex-wrap" }
const _hoisted_2 = { class: "p-float-label p-mr-auto model-search" }
const _hoisted_3 = { class: "kn-material-input-label" }
const _hoisted_4 = { class: "kn-overflow" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 0,
  class: "fas fa-check p-button-link"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_8 = {
  key: 1,
  class: "p-grid p-m-2",
  "data-test": "card-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_KnFabButton = _resolveComponent("KnFabButton")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_ProgressBar = _resolveComponent("ProgressBar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_MultiSelect = _resolveComponent("MultiSelect")
  const _component_SelectButton = _resolveComponent("SelectButton")
  const _component_Column = _resolveComponent("Column")
  const _component_Chip = _resolveComponent("Chip")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Message = _resolveComponent("Message")
  const _component_WorkspaceCard = _resolveComponent("WorkspaceCard")
  const _component_DetailSidebar = _resolveComponent("DetailSidebar")
  const _component_KnParameterSidebar = _resolveComponent("KnParameterSidebar")
  const _component_DatasetWizard = _resolveComponent("DatasetWizard")
  const _component_EditPreparedDatasetDialog = _resolveComponent("EditPreparedDatasetDialog")
  const _component_TieredMenu = _resolveComponent("TieredMenu")
  const _component_Menu = _resolveComponent("Menu")
  const _component_WorkspaceDataCloneDialog = _resolveComponent("WorkspaceDataCloneDialog")
  const _component_WorkspaceDataShareDialog = _resolveComponent("WorkspaceDataShareDialog")
  const _component_WorkspaceDataPreviewDialog = _resolveComponent("WorkspaceDataPreviewDialog")
  const _component_WorkspaceWarningDialog = _resolveComponent("WorkspaceWarningDialog")
  const _component_DataPreparationAvroHandlingDialog = _resolveComponent("DataPreparationAvroHandlingDialog")
  const _component_QBE = _resolveComponent("QBE")
  const _component_DataPreparationMonitoringDialog = _resolveComponent("DataPreparationMonitoringDialog")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, {
      class: "kn-toolbar kn-toolbar--secondary",
      style: _ctx.mainDescriptor.style.maxWidth
    }, {
      start: _withCtx(() => [
        _createVNode(_component_Button, {
          id: "showSidenavIcon",
          icon: "fas fa-bars",
          class: "p-button-text p-button-rounded p-button-plain",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('showMenu')))
        }),
        _createTextVNode(" " + _toDisplayString(_ctx.$t('workspace.myData.title')), 1)
      ]),
      end: _withCtx(() => [
        (_ctx.toggleCardDisplay)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              icon: "fas fa-list",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.toggleDisplayView
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (!_ctx.toggleCardDisplay)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 1,
              icon: "fas fa-th-large",
              class: "p-button-text p-button-rounded p-button-plain",
              onClick: _ctx.toggleDisplayView
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.tableMode === 'My Datasets')
          ? (_openBlock(), _createBlock(_component_KnFabButton, {
              key: 2,
              icon: "fas fa-plus",
              "data-test": "new-folder-button",
              onClick: _ctx.showCreationMenu
            }, null, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["style"]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_ProgressBar, {
          key: 0,
          mode: "indeterminate",
          class: "kn-progress-bar p-ml-2",
          "data-test": "progress-bar"
        }))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_InputText, {
        class: "kn-material-input p-m-3 model-search",
        style: _ctx.mainDescriptor.style.filterInput,
        modelValue: _ctx.searchWord,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.searchWord = $event)),
        type: "text",
        placeholder: _ctx.$t('common.search'),
        onInput: _ctx.searchItems,
        "data-test": "search-input"
      }, null, 8, ["style", "modelValue", "placeholder", "onInput"]),
      _createVNode("span", _hoisted_2, [
        _createVNode(_component_MultiSelect, {
          class: "kn-material-input kn-width-full",
          style: _ctx.mainDescriptor.style.multiselect,
          modelValue: _ctx.selectedCategories,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.selectedCategories = $event)),
          options: _ctx.datasetCategories,
          optionLabel: "VALUE_CD",
          onChange: _ctx.searchItems,
          filter: true
        }, null, 8, ["style", "modelValue", "options", "onChange"]),
        _createVNode("label", _hoisted_3, _toDisplayString(_ctx.$t('common.category')), 1)
      ]),
      _createVNode(_component_SelectButton, {
        class: "p-mx-2",
        modelValue: _ctx.tableMode,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.tableMode = $event)),
        options: _ctx.selectButtonOptions,
        onClick: _ctx.getDatasetsByFilter,
        "data-test": "dataset-select"
      }, null, 8, ["modelValue", "options", "onClick"])
    ]),
    _createVNode("div", _hoisted_4, [
      (!_ctx.toggleCardDisplay)
        ? (_openBlock(), _createBlock(_component_DataTable, {
            key: 0,
            class: "p-datatable-sm kn-table p-mx-2",
            value: _ctx.filteredDatasets,
            loading: _ctx.loading,
            dataKey: "objId",
            responsiveLayout: "stack",
            breakpoint: "600px",
            "data-test": "datasets-table"
          }, {
            empty: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
            ]),
            default: _withCtx(() => [
              _createVNode(_component_Column, {
                field: "label",
                header: _ctx.$t('importExport.catalogFunction.column.label'),
                class: "kn-truncated",
                sortable: true
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "name",
                header: _ctx.$t('importExport.gallery.column.name'),
                class: "kn-truncated",
                sortable: true
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "dsTypeCd",
                header: _ctx.$t('importExport.gallery.column.type'),
                sortable: true
              }, null, 8, ["header"]),
              _createVNode(_component_Column, {
                field: "tags",
                header: _ctx.$t('importExport.gallery.column.tags'),
                sortable: true
              }, {
                body: _withCtx((slotProps) => [
                  (slotProps.data.tags.length > 0)
                    ? (_openBlock(), _createBlock("span", _hoisted_5, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(slotProps.data.tags, (tag, index) => {
                          return (_openBlock(), _createBlock(_component_Chip, { key: index }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(tag.name), 1)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                header: _ctx.$t('workspace.myData.parametrical')
              }, {
                body: _withCtx((slotProps) => [
                  (slotProps.data.pars.length > 0 || slotProps.data.drivers.length > 0)
                    ? (_openBlock(), _createBlock("i", _hoisted_6))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["header"]),
              _createVNode(_component_Column, {
                style: _ctx.mainDescriptor.style.iconColumn
              }, {
                header: _withCtx(() => [
                  _hoisted_7
                ]),
                body: _withCtx((slotProps) => [
                  _createVNode(_component_Button, {
                    icon: "fas fa-ellipsis-v",
                    class: "p-button-link",
                    onClick: _withModifiers(($event: any) => (_ctx.showMenu($event, slotProps.data)), ["stop"])
                  }, null, 8, ["onClick"]),
                  _withDirectives(_createVNode(_component_Button, {
                    icon: "fas fa-info-circle",
                    class: "p-button-link",
                    onClick: _withModifiers(($event: any) => (_ctx.showSidebar(slotProps.data)), ["stop"]),
                    "data-test": 'info-button-' + slotProps.data.name
                  }, null, 8, ["onClick", "data-test"]), [
                    [
                      _directive_tooltip,
                      _ctx.$t('workspace.myModels.showInfo'),
                      void 0,
                      { left: true }
                    ]
                  ]),
                  _createVNode(_component_Button, {
                    icon: "fas fa-eye",
                    class: "p-button-link",
                    onClick: _withModifiers(($event: any) => (_ctx.previewDataset(slotProps.data)), ["stop"])
                  }, null, 8, ["onClick"])
                ]),
                _: 1
              }, 8, ["style"])
            ]),
            _: 1
          }, 8, ["value", "loading"]))
        : _createCommentVNode("", true),
      (_ctx.toggleCardDisplay)
        ? (_openBlock(), _createBlock("div", _hoisted_8, [
            (_ctx.filteredDatasets.length === 0)
              ? (_openBlock(), _createBlock(_component_Message, {
                  key: 0,
                  class: "kn-flex p-m-2",
                  severity: "info",
                  closable: false,
                  style: _ctx.mainDescriptor.style.message
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
                  ]),
                  _: 1
                }, 8, ["style"]))
              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.filteredDatasets, (dataset, index) => {
                  return (_openBlock(), _createBlock(_component_WorkspaceCard, {
                    key: index,
                    viewType: 'dataset',
                    document: dataset,
                    isAvroReady: _ctx.isAvroReady(dataset.id),
                    onPreviewDataset: _ctx.previewDataset,
                    onEditDataset: _ctx.editDataset,
                    onOpenDatasetInQBE: _cache[5] || (_cache[5] = ($event: any) => (_ctx.openDatasetInQBE($event))),
                    onExportToXlsx: _cache[6] || (_cache[6] = ($event: any) => (_ctx.prepareDatasetForExport($event, 'xls'))),
                    onExportToCsv: _cache[7] || (_cache[7] = ($event: any) => (_ctx.prepareDatasetForExport($event, 'csv'))),
                    onDownloadDatasetFile: _ctx.downloadDatasetFile,
                    onShareDataset: _ctx.shareDataset,
                    onCloneDataset: _ctx.cloneDataset,
                    onDeleteDataset: _ctx.deleteDatasetConfirm,
                    onOpenDataPreparation: _ctx.openDataPreparation,
                    onOpenSidebar: _ctx.showSidebar,
                    onMonitoring: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showMonitoring = !_ctx.showMonitoring))
                  }, null, 8, ["document", "isAvroReady", "onPreviewDataset", "onEditDataset", "onDownloadDatasetFile", "onShareDataset", "onCloneDataset", "onDeleteDataset", "onOpenDataPreparation", "onOpenSidebar"]))
                }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_DetailSidebar, {
      visible: _ctx.showDetailSidebar,
      viewType: 'dataset',
      document: _ctx.selectedDataset,
      isAvroReady: _ctx.isAvroReady(_ctx.selectedDataset?.id),
      datasetCategories: _ctx.datasetCategories,
      onPreviewDataset: _ctx.previewDataset,
      onEditDataset: _ctx.editDataset,
      onOpenDatasetInQBE: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openDatasetInQBE($event))),
      onExportToXlsx: _cache[10] || (_cache[10] = ($event: any) => (_ctx.prepareDatasetForExport($event, 'xls'))),
      onExportToCsv: _cache[11] || (_cache[11] = ($event: any) => (_ctx.prepareDatasetForExport($event, 'csv'))),
      onDownloadDatasetFile: _ctx.downloadDatasetFile,
      onShareDataset: _ctx.shareDataset,
      onCloneDataset: _ctx.cloneDataset,
      onDeleteDataset: _ctx.deleteDatasetConfirm,
      onOpenDataPreparation: _ctx.openDataPreparation,
      onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.showDetailSidebar = false)),
      "data-test": "detail-sidebar",
      onMonitoring: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showMonitoring = !_ctx.showMonitoring))
    }, null, 8, ["visible", "document", "isAvroReady", "datasetCategories", "onPreviewDataset", "onEditDataset", "onDownloadDatasetFile", "onShareDataset", "onCloneDataset", "onDeleteDataset", "onOpenDataPreparation"]),
    (_ctx.parameterSidebarVisible)
      ? (_openBlock(), _createBlock("div", {
          key: 1,
          id: "document-execution-backdrop",
          onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.parameterSidebarVisible = false))
        }))
      : _createCommentVNode("", true),
    (_ctx.parameterSidebarVisible)
      ? (_openBlock(), _createBlock(_component_KnParameterSidebar, {
          key: 2,
          style: {"height":"100%","top":"0 !important"},
          class: "workspace-parameter-sidebar kn-overflow-y",
          filtersData: _ctx.filtersData,
          propDocument: _ctx.selectedDataset,
          propMode: 'workspaceView',
          propQBEParameters: _ctx.selectedDataset.pars,
          userRole: _ctx.userRole,
          dataset: _ctx.selectedDataset,
          onExecute: _ctx.onExecute,
          onRoleChanged: _ctx.onRoleChange
        }, null, 8, ["filtersData", "propDocument", "propQBEParameters", "userRole", "dataset", "onExecute", "onRoleChanged"]))
      : _createCommentVNode("", true),
    (_ctx.showDatasetDialog)
      ? (_openBlock(), _createBlock(_component_DatasetWizard, {
          key: 3,
          selectedDataset: _ctx.selectedDataset,
          visible: _ctx.showDatasetDialog,
          onCloseDialog: _cache[15] || (_cache[15] = ($event: any) => (_ctx.showDatasetDialog = false)),
          onCloseDialogAndReload: _ctx.closeWizardAndRealod
        }, null, 8, ["selectedDataset", "visible", "onCloseDialogAndReload"]))
      : _createCommentVNode("", true),
    _createVNode(_component_EditPreparedDatasetDialog, {
      dataset: _ctx.selectedDataset,
      visible: _ctx.showEditPreparedDatasetDialog,
      onSave: _ctx.updatePreparedDataset,
      onCancel: _cache[16] || (_cache[16] = ($event: any) => (_ctx.showEditPreparedDatasetDialog = false))
    }, null, 8, ["dataset", "visible", "onSave"]),
    _createVNode(_component_TieredMenu, {
      class: "kn-tieredMenu",
      id: "optionsMenu",
      ref: "optionsMenu",
      model: _ctx.menuButtons,
      popup: true
    }, null, 8, ["model"]),
    _createVNode(_component_Menu, {
      id: "creationMenu",
      ref: "creationMenu",
      model: _ctx.creationMenuButtons
    }, null, 8, ["model"]),
    _createVNode(_component_WorkspaceDataCloneDialog, {
      visible: _ctx.cloneDialogVisible,
      propDataset: _ctx.selectedDataset,
      onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.cloneDialogVisible = false)),
      onClone: _ctx.handleDatasetClone
    }, null, 8, ["visible", "propDataset", "onClone"]),
    _createVNode(_component_WorkspaceDataShareDialog, {
      visible: _ctx.shareDialogVisible,
      propDataset: _ctx.selectedDataset,
      datasetCategories: _ctx.datasetCategories,
      onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.shareDialogVisible = false)),
      onShare: _ctx.handleDatasetShare
    }, null, 8, ["visible", "propDataset", "datasetCategories", "onShare"]),
    (_ctx.previewDialogVisible)
      ? (_openBlock(), _createBlock(_component_WorkspaceDataPreviewDialog, {
          key: 4,
          visible: _ctx.previewDialogVisible,
          propDataset: _ctx.selectedDataset,
          onClose: _cache[19] || (_cache[19] = ($event: any) => (_ctx.previewDialogVisible = false)),
          previewType: "workspace"
        }, null, 8, ["visible", "propDataset"]))
      : _createCommentVNode("", true),
    _createVNode(_component_WorkspaceWarningDialog, {
      visible: _ctx.warningDialogVisbile,
      title: _ctx.$t('workspace.myData.title'),
      warningMessage: _ctx.warningMessage,
      onClose: _ctx.closeWarningDialog
    }, null, 8, ["visible", "title", "warningMessage", "onClose"]),
    _createVNode(_component_DataPreparationAvroHandlingDialog, {
      visible: _ctx.dataPrepAvroHandlingDialogVisbile,
      title: _ctx.$t('workspace.myData.isPreparing'),
      infoMessage: _ctx.dataPrepAvroHandlingMessage,
      onClose: _ctx.proceedToDataPrep,
      events: _ctx.events
    }, null, 8, ["visible", "title", "infoMessage", "onClose", "events"]),
    (_ctx.qbeVisible)
      ? (_openBlock(), _createBlock(_component_QBE, {
          key: 5,
          visible: _ctx.qbeVisible,
          dataset: _ctx.selectedQbeDataset,
          sourceDataset: _ctx.selectedDataset,
          onClose: _ctx.closeQbe
        }, null, 8, ["visible", "dataset", "sourceDataset", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_DataPreparationMonitoringDialog, {
      visibility: _ctx.showMonitoring,
      "onUpdate:visibility": _cache[20] || (_cache[20] = ($event: any) => (_ctx.showMonitoring = $event)),
      onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.showMonitoring = false)),
      onSave: _ctx.updateDatasetWithNewCronExpression,
      dataset: _ctx.selectedDataset
    }, null, 8, ["visibility", "onSave", "dataset"])
  ], 64))
}